import { render, staticRenderFns } from "./FormProject.vue?vue&type=template&id=5d4bb20f&"
import script from "./FormProject.vue?vue&type=script&lang=js&"
export * from "./FormProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports